import { render, staticRenderFns } from "./GenerateReturnLabel.vue?vue&type=template&id=34a4898d&"
import script from "./GenerateReturnLabel.vue?vue&type=script&lang=js&"
export * from "./GenerateReturnLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports